import type { SVGProps } from 'react'
const SvgSyTron = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" width={24} height={24} {...props}>
		<path d="M133.6 43.9c-6.4-5.9-15.2-14.9-22.4-21.3l-.4-.3c-.7-.6-1.5-1-2.4-1.3C91.1 17.8 10.5 2.7 8.9 2.9c-.4 0-.9.2-1.2.5l-.4.3c-.5.5-.9 1.1-1.1 1.8v.3c-.1 0-.1 1.5-.1 1.5v.2C15.2 32.8 51 115.6 58.1 135c.4 1.3 1.2 3.8 2.7 4h.3c.8 0 4.3-4.5 4.3-4.5s61.6-74.7 67.8-82.6c.8-1 1.5-2 2.1-3.1.3-1.8-.3-3.6-1.7-4.8zm-52.4 8.7 26.3-21.8L122.9 45zM71 51.2 25.8 14.1 99 27.6zm4.1 9.7 46.3-7.5-52.9 63.8zM19.6 17.8l47.6 40.4-6.9 59.1z" />
	</svg>
)
export default SvgSyTron
